import { Exercise, MssHyroxMainPart, MssHyroxZone } from "@/types/workouts";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import ExerciseTileComponent from "../exercise-tile/exercise-tile.component.vue";

@Component({
    components: {
        'exercise-tile-component': ExerciseTileComponent
    }
})
export default class HyroxRoundPreviewComponent extends Vue {
    @Prop({}) roundData!: MssHyroxZone[]
    @Prop({}) activeZone!: number

    get activeData() {
        return this.roundData[this.activeZone]
    }

    public swiperOption: any = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        speed: 400,
        observer: true,
        observeParents: true
    };

    nextSlide() {
        this.workoutSwiper.$swiper.slideNext()
    }

    prevSlide() {
        this.workoutSwiper.$swiper.slidePrev()
    }

    get workoutSwiper(): any {
        return this.$refs.workoutSwiper
    }
}